import React from 'react';
import styled from 'styled-components';
import PropTypes from 'prop-types';
import COLORS from '../../common/styles/color-pallete';
import { FONT_FAMILY } from '../../common/styles/fontStyles';

export const ModalWrapper = styled.div`
  position: absolute;
  height: 270vh;
  top: 0;
  left: 0;
  width: 100%;
  z-index: 11;
  background-color: rgba(255, 255, 255, 0.8);

  .modalBox {
    position: absolute;
    margin-left: 6%;
    top: 503px;
    width: 90%;
    height: auto;
    object-fit: contain;
    border-radius: 4px;
    box-shadow: 2px 2px 10px 0 rgba(0, 0, 0, 0.1);
    border: solid 1px #f7f7f7;
    background-color: ${COLORS.white};

    .contentWrapper {
      width: 100%;
      display: flex;
      flex-direction: column;
      align-items: center;

      .crossButton {
        font-size: 20px;
        color: #00c1ff;
        width: 100%;
        font-family: ${FONT_FAMILY.hellix.regular};
        display: flex;
        justify-content: flex-end;
        margin-right: 15px;
        margin-bottom: 36px;
        margin-top: 19px;
        background-color: transparent;
        border: none;
        button {
          background-color: transparent;
          border: none;
          color: ${COLORS.black};
        }
      }

      .title {
        font-family: ${FONT_FAMILY.hellix.regular};
        font-size: 16px;
        font-weight: 900;
        font-stretch: normal;
        font-style: normal;
        line-height: normal;
        letter-spacing: normal;
        color: ${COLORS.black};
        margin-top: 23px;
      }

      .content {
        object-fit: contain;
        font-family: ${FONT_FAMILY.hellix.regular};
        font-size: 12px;
        font-weight: normal;
        font-stretch: normal;
        font-style: normal;
        line-height: 1.83;
        letter-spacing: normal;
        text-align: center;
        color: #1a1a1a;
        margin: 23px 0px 20px 0px;
        width: 85%;
      }

      .closeButtonText {
        width: 100%;
        font-size: 18px;
        font-weight: 500;
        font-stretch: normal;
        font-style: normal;
        line-height: 1.67;
        letter-spacing: 0.64px;
        text-align: center;
        color: #354087;
        margin-top: 10px;
        margin-bottom: 10px;
        button {
          color: ${COLORS.black};
          width: 88px;
          background-color: ${COLORS.brandSecondary};
          border: none;
          text-transform: uppercase;
          padding: 8px;
          font-weight: bold;
          border-radius: 4px;
          font-family: ${FONT_FAMILY.hellix.regular};
        }
      }
    }
  }
`;

function Modal(props) {
  const { title, content, closeModal, id } = props;
  return (
    <ModalWrapper>
      <div className="modalBox">
        <div className="contentWrapper">
          <div className="crossButton">
            <button onClick={closeModal}>X</button>
          </div>
          <div className="title">
            <p>{title || 'Add a title'}</p>
          </div>
          <div id={id} className="content">
            {content || 'Add the content body'}
          </div>
          <div className="closeButtonText">
            <button onClick={props.closeModal}>Close</button>
          </div>
        </div>
      </div>
    </ModalWrapper>
  );
}

Modal.propTypes = {
  closeModal: PropTypes.any,
  title: PropTypes.any,
  content: PropTypes.any,
  id: PropTypes.string
};

export default Modal;
